import { PatientId } from '@app/icare/entities/patient/schema/PatientId'

export const TOUR_PATIENT_ID = PatientId.ref.parse('patient_97ba1b1e814b45e387187fe47a6c8e6d')
